import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Popover } from 'antd';
import classNames from 'classnames';
import setImageSize, {
  isGuest, valueToObject,
} from 'Utils/UtilityFunctions';
import HTMLReactParser from 'html-react-parser';
import SocialShareIcons from 'Components/share/SocialShareIcons';
import { Article } from 'Types/ArticleTypes';
import {
  useDispatch, useSelector,
} from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { actions as favouriteArticleActions } from 'Slice/FavoriteArticlesSlice';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { selectData, selectIsCertificationCompleted, selectOpenDrawer } from 'Selector/CertificationSelector';
import Iframe from 'react-iframe';
import {
  boxShadow, primaryColor, primaryFont, wMedium, maxWidth, retina, min,
  favouriteArticleColor, whiteColor, secondaryFont,
  wLight, minWidthApp, primaryHeadingColor, maxTablet, maxMobile, smMobile,
} from '../../../Utils/utilsStyle';
import PeopleWidget from './PeopleWidget';
import LinkedInIcon from '../assets/svgIcons/LinkedInIcon';
import FavoriteIcon from '../assets/svgIcons/FavoriteIcon';
import ArticleDrawer from './ArticleDrawer';
import TwitterIcon from '../assets/svgIcons/TwitterIcon';
import ShareArticleIcon from '../assets/svgIcons/ShareArticleIcon';

const ArticleWrapper = styled.div<{ triggerColor: string, articleHeight: string, articleHeightSm: string }>`
  border-radius: 8px !important;
  padding: 0px !important;
  position: relative;
  z-index: 0;
  .share-actions-with-fav {
    display: flex;
    align-items: center;
    margin-top: 7px;
  }
  .footer-data-article {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &.spotlightMiniTileView {
   &:before {
    content: '';
    width: 5px;
    height: 100%;
    border-radius: 10px 0px 0px 10px;
    position: absolute;
    background-color: ${(props) => props.triggerColor};
    z-index: 1;
    top: 0px;
    left: 3px;
    transform: translateX(-50%);
   }
   .profile-area {
    &:before {
      display: none;
    }
   }
   .article_summary{
    display: none;
   }
  }
  .ant-popover-inner-content{
    padding: 0;
  }
  .ant-popover-inner {
    border-radius: 16px;
  }
  .newsVideoFrame{
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
  }
  .text-area {
    background: #fff;
    border-radius: 0px 0px 8px 8px;
    .footer-data-article {
      .bottom-tips {
        max-width: calc(100% - 40px);
      }
      .ant-popover-inner-content {
        .teams-share-button {
          &:before {
             width: 16px;
             height: 16px;
             margin-top: 8px;
          }
        }
        svg{
          width: 16px !important;
          height:auto;
          margin-right: 4px;
        }
      }
    }
  }
  &.searchTile {
    height: fit-content;
    margin-bottom: 0px;
    .person-activity-text-detail {
      padding: 16px !important;
    }
    .heading {
      padding: 0px !important;
      min-height: auto !important;
    }
    .tagArticle {
      font-size: 10px;
      padding: 0px 10px;
      right: 10px;
      top: 13px;
    }
    .article_summary{
      display: none;
    }
    &.searchTileWithOutTag {
      .heading {
        width: 89%;
        @media all and (min-width:1281px) and (max-width:1480px){
          width: 85%;
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 87%;
        }
        @media all and (max-width: ${minWidthApp}){
          width: 70%;
        }
      }
    }
    .text-area {
      .footer-data-article {
        .ant-popover-inner-content {
          .teams-share-button {
            &:before {
             width: 16px;
             height: 16px;
            }
          }
        }
      }
    }
  }
  &.socialActive {
    .profile-area{
      border-radius:50%;
      position:relative;
      svg{
        width: 30px;
        height: 30px;
        position: absolute;
        right: 0px;
        bottom: -6px;
      }
      &:before {
        display: none;
      }
      img {
        border-radius:50%;
      }
    }
  }
  &.heroView {
    display: block;
    box-shadow: ${boxShadow};
    .text-area {
      .popover-sharing {
        bottom: 24px;
        top: unset;
      }
    }
    .profile-area {
     min-width:100%;
     min-height: ${(props) => props.articleHeight}px;
     width:auto;
     border-radius: 8px 8px 0px 0px;
     position: relative;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        min-height: ${(props) => props.articleHeightSm}px;
      }
      @media all and (max-width: ${minWidthApp}) {
        min-height: 160px; 
      }
      &.videoPlayIframe {
        min-height: ${(props) => props.articleHeight}px;
      }
      &:before {
        display: none;
        height: 100%;
        width: 6px;
        left: 3px;
        border-radius: 12px 0px 0px 0px;
      }
      .lazy-load-image-background{
       width:100%;
       img {
        border-radius: 8px 8px 0px 0px;
        object-fit: cover;
       }
      }
    }
    .text-area {
      padding: 0px;
      margin: 0px;
      min-width: auto;
      position: relative;
      &:before {
        content: '';
        height: 100%;
        border-radius: 0px 0px 0px 12px;
        position: absolute;
        width: 6px;
        background-color: ${(props) => props.triggerColor};
        z-index: 1;
        bottom: 0px;
        left: 3px;
        transform: translateX(-50%);
        @media all and (max-width: ${min}){
          height: 100%;
          border-radius: 0px 0px 0px 12px;
        }
      }

      @media all and (max-width: ${maxWidth}) , ${retina} {
        padding: 0px;
        border-radius: 0px 0px 8px 8px;
      }

      .heading {
       font-size: 14px;
       line-height: 18px;
       min-height: 62px;
       @media all and (max-width: ${maxTablet}) {
        font-size: 11px;
        line-height: 15px;
        min-height: 55px;
       }
      }
      .favorite-icon {
       bottom: 12px;
       @media all and (max-width: ${maxWidth}) , ${retina} {
          bottom: 10px;
      }
      }
      .bottom-tips {
        .tips {
         font-size:12px;
         line-height:18px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            font-size: 10px;
          }
        }
      }
      .person-activity-text-detail {
        padding: 0px;
      }
    }
  }
  &.activityActive {
    .tagArticle {
      padding: 2px 10px;
      font-size: 14px;
    }
    .text-area {
      display: flex;
      align-items: center;
      border-radius: 0px 0px 8px 8px;
      padding: 0px;
      border-top: 1px solid #DADADA;
      > div {
        width: 100%;
      }
      .heading {
        padding: 12px 20px 5px 10px;
        font-size: 18px;
        line-height: 24px;
        min-height: 0px;
        @media all and (max-width: ${maxWidth}),${retina} {
          font-size: 16px;
        }
        @media all and (max-width: ${maxTablet}) {
         font-size: 12px;
         line-height: 14px;
         padding: 12px 20px 0 10px;
        }
      }
      .article_summary{
        padding: 8px 20px 3px 10px;
        line-height: 20px;
        font-size: 15px;
        font-weight: ${wMedium};
        letter-spacing: -0.56px;
        font-family: ${primaryFont};
        color: #7E7E7E;
        @media all and (max-width: ${maxWidth}),${retina} {
          font-size: 12px;
          line-height: 18px;
        }
      }
      .footer-data-article {
        padding: 0px 20px 10px 10px;
      }
      a {
      display: flex;
      align-items: center;
      }
      .person-area-activity {
        position: relative;
        div {
          margin-bottom: 0px;
        }
        .social-platform-placeholder {
          position: absolute;
          right: 0px;
          bottom: 0px;
          svg {
              background-color: #fff;
          }
        }
      }
      .person-activity-text-detail {
         margin-left: 15px;
      }
    }
  }
  .lazy-load-image-background {
    width: 100%;
    height: 100%;
    &.blur {
    filter: blur(15px);
    }
    &.lazy-load-image-loaded {
      filter: none !important;
    }
  }
  .profile-area {
      height: 72px;
      width: 72px;
      @media all and (max-width: ${minWidthApp})
      {
        height: 60px;
        width: 60px;
        min-width: 60px;
      }
      border-radius: 10px;
      position: relative;
      z-index: 0;
      @media all and (max-width: ${min}){
        height: 51px !important;
        width: 51px !important;
        min-width: 51px;
        border-radius: 7px;
      }
      &:before {
        content: '';
        height: 7px;
        border-radius: 0px 0px 10px 10px;
        position: absolute;
        width: 100%;
        background-color: ${(props) => props.triggerColor};
        z-index: 1;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        @media all and (max-width: ${min}){
          height: 4px;
          border-radius: 0px 0px 7px 7px;
        }
      }
    img {
     width: 100%;
     height: 100%;
     border-radius: 10px;
    }
  }
  .text-area {
    .heading {
      font-size: 12px;
      line-height: 14px;
      min-height: 42px;
      font-weight: ${wMedium};
      padding: 0px 115px 0px 0px;
      @media all and (max-width: ${maxTablet}) {
        font-size: 11px;
        line-height: 14px;
      }
      @media all and (max-width: ${maxMobile}) {
        min-height: 24px;
      }
    }
    .bottom-tips {
      .tips {
        font-size: 11px;
        line-height: 11px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 10px;
        }
      }
    }
    .favorite-icon {
      position: absolute;
      bottom: 0px;
      right: 40px;
      svg {
        &:hover {
          cursor: pointer;
        }
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        bottom: 15px;
        right: 40px;
      }
    }
  }
  &.topNewsStyle {
    .tagArticle {
      top: -40px;
    }
    .popover-sharing{
     top: 0px !important;
    }
  }
  &.topWithImgTile {
    box-shadow: none !important;
    background: transparent !important;
    &.notHeroView {
      &.article-item {
        padding: 0px !important;
      }
      .text-area {
        .popover-sharing {
          bottom: 2px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            bottom: 9px;
          }
        }
      }
    }
  }
  &.notHeroView {
    box-shadow: ${boxShadow};
    background-color: #fff;
    &.article-item {
     padding: 8px 11px 8px 16px !important;
     margin-bottom: 8px;
     .profile-area {
      &:before {
        height: 100%;
        width: 7px;
        bottom: 0px;
        left: 3px !important;
        top: 0px;
        border-radius: 12px 0px 0px 12px;
      }
     }
    }
    .text-area {
      min-width: calc(100% - 84px);
      @media all and (max-width: ${minWidthApp}) and (min-width: ${maxTablet}){
        min-width: calc(100% - 70px);
      }
      @media all and (max-width: ${maxMobile}) {
        min-width: calc(100% - 64px);
      }
      .popover-sharing {
       bottom: 10px;
       top: unset;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          bottom: 15px;
        }
      }
    }
  }
  &.notImage {
    position: relative;
    &:before {
      content: '';
      width: 5px;
      height: 100%;
      border-radius: 10px 0px 0px 10px;
      position: absolute;
      background-color: ${(props) => props.triggerColor};
      z-index: 1;
      top: 0px;
      left: 3px;
      transform: translateX(-50%);
    }
    .popover-sharing {
      top: unset;
      bottom: 20px !important;
    }

    .profile-area{
      display:none;
    }
    .text-area {
      border-radius: 8px;
      height: 100%;
      display: flex;
      align-items: center;
      .heading {
        padding: 55px 15px 3px 10px;
        @media all and (max-width: ${maxTablet}) {
          padding: 55px 15px 0px 10px;
        }
      }
      .favorite-icon {
        bottom: 8px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
            bottom: 6px;
        }
      }
    }
  }
  &.spotlight-heroTile-style {
    &.heroView {
      .text-area {
        .popover-sharing {
          bottom: 10px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            bottom: 15px;
          }
        }
        .heading {
          padding: 8px 11px 0px 16px;
          @media all and (max-width: ${maxTablet}){
           padding: 8px 5px 0px 10px; 
          }
        }
        .article_summary{
          display: none;
        }
        .footer-data-article {
          padding: 0px 11px 8px 16px;
          @media all and (max-width: ${maxTablet}){
             padding: 0px 5px 8px 10px;
          }
        }
        .favorite-icon {
          bottom: 0px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            bottom: 17px;
            right: 40px;
          }
        }
      }
    }
  }
  .favorite-icon-custom {
    margin-right: 8px;
  }
  .favorite-icon-custom, .popover-sharing-custom {
    height: 15px;
  }
`;

const ArticleListWrapper = styled.div<{
  triggerColor: string, summaryPadding: string,
}>`
  background-color: #fff;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  position: relative;
  height: 117px;
  padding: 0px 10px 0px 10px;
  margin-bottom: 8px;
  box-shadow: ${boxShadow};
  z-index: 0;
  @media all and (max-width: ${maxTablet}){
    height: auto;
  }
  &:before {
    content: '';
    width: 5px;
    height: 100%;
    border-radius: 10px 0px 0px 10px;
    position: absolute;
    background-color: ${(props) => props.triggerColor};
    z-index: 1;
    top: 0px;
    left: 3px;
    transform: translateX(-50%);
   }
  .profile-area {
    height: 85px;
    width: 85px;
    min-width: 85px;
    border-radius: 8px;
    margin-left: 5px;
    @media all and (max-width: ${maxTablet}){
      height: 51px;
      width: 51px;
      min-width: 51px;
    }
    .img-fluid {
      border-radius: 8px;
    }
  }
  &.notImage {
    @media all and (max-width: ${maxTablet}) {
      padding: 0px;
    }
    .text-area {
      width: 100%;
    }
  }
  .text-area {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 17px 0px 17px 0px;
    justify-content: center;
    width: calc(100% - 100px);
    @media all and (max-width: ${maxTablet}){
      padding: 8px 0px;
      min-width: calc(100% - 60px);
    }
    .title-summary-div {
      padding-right: 50px;
      &.tagArticleSummary {
        padding-right: 100px;
        @media all and (max-width: ${minWidthApp}) {
          padding-right: 140px;
          margin-right: 5px;
        }
        @media all and (max-width: ${maxTablet}) {
          padding-right: ${(props) => (props.summaryPadding ? props.summaryPadding : '145px')};
        
        }
        @media all and (max-width: ${smMobile}) {
          padding-right: 150px;
        }
      }
    }
    .tagArticle {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 12px;
      line-height: 16.43px;
      @media all and (max-width: ${maxMobile}) { 
        top: 10px;
      }
    }
    .heading {
      font-family: ${secondaryFont};
      font-weight: ${wMedium};
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.45px;
      color: ${primaryHeadingColor};
      @media all and (max-width: ${maxTablet}){
        font-size: 13px;
        line-height: 16px;
      }
    }
    .article_summary {
      min-height: 12px;
      font-family: ${primaryFont};
      font-weight: ${wLight};
      font-size: 12px;
      line-height: 20px;
      letter-spacing: -0.56px;
      color: #7E7E7E;
      margin-top: 0px;
    }
    .ant-popover-inner {
      border-radius: 16px;
    }
    .footer-data-article {
      display: flex !important;
      justify-content: space-between;
      padding: 0px 10px 0px 0px;
      margin-top: 10px;
      height: 12px;
      .bottom-tips {
        display: flex;
        @media all and (max-width: ${maxTablet}) {
          max-width: 80%;
        }
        @media all and (max-width: ${smMobile}){
          width: calc(100% - 50px);
        }
      }
      .ant-popover-inner-content {
        padding: 0px;
        .teams-share-button {
          &:before {
             width: 16.5px;
             height: 16.5px;
             margin-top: 4px;
             @media all and (max-width: ${maxWidth}) , ${retina} {
              margin-top: 2px;
             }
          }
        }
        svg{
          width: 16px !important;
          height:auto;
          margin-right: 4px;
        }
      }
      .tips {
        font-family: ${primaryFont};
        font-weight: ${wMedium};
        font-size: 11px;
        line-height: 11px;
        @media all and (max-width: ${maxTablet}) {
          font-size: 8px;
        }
        &.domain {
          color: #DB3725;
          border-right: 1.5px solid #7E7E7E;
          padding: 0px 5px 0px 0px;
          @media all and (max-width: ${smMobile}) {
            max-width:60%;
          }
        }
        &.date {
          color: #7E7E7E;
          border-right: 1.5px solid #7E7E7E;
          padding: 0px 5px;
          @media all and (max-width: ${smMobile}) {
            max-width:20%
          }
        }
        &.industry {
          color: ${primaryColor};
          margin-left: 5px;
          @media all and (max-width: ${smMobile}) {
            max-width:20%;
          }
        }
      }
      .share-actions-with-fav {
        @media all and (max-width: ${smMobile}){
          min-width: 45px;
        }
        .favorite-icon-custom {
          margin-right: 10px;
        }
        .article-share-icon {
          .ant-popover {
            top: 45px !important;
          }
          &.listviewShareIcon {
            .ant-popover {
              @media all and (max-width: ${maxTablet}) {
                top: 1px !important;
              }
            }
          }
        }
      }
    }
  }
`;

const ContentWrapper = styled.div`
&.highlightsTabPopover {
  .share-icons-wrapper {
    .evernote-share-button{
      .evanote-icon {
        margin-top: -6px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          margin-top: -5px;
        }
      }
    }
  }
}
  min-width: 238px;
  padding: 10px 15px;
  border-radius: 16px;
  box-shadow: ${boxShadow};
  @media all and (max-width: ${maxWidth}) , ${retina} {
    min-width: 200px;
    padding: 14px 18px;
  }
  .heading-popover {
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    color: ${primaryColor};
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
    }
  }
`;

const ArticleTag = styled.span <{ tagColor: string }>`
 font-size: 20px;
 padding: 0px 10px;
 color: #fff;
 border: 1px solid #fff;
 font-weight: ${wMedium};
 font-family: ${primaryFont};
 border-radius: 12px;
 background-color: ${(props) => props.tagColor};
 line-height: 18px;
 letter-spacing: -0.29px;
 position: absolute;
 right: 17px;
 top: 15px;
 z-index: 1;
`;

type Props = {
  hideCompanyName?: boolean,
  favoritePageFlag?: boolean,
  heroArticle?: boolean,
  socialActivity?: boolean,
  activityTile?: boolean,
  personPersona?: string,
  personImage?: string,
  articleHeight?: string;
  articleHeightSm?: string;
  articleWidth?: number | string;
  searchArticleTile?: boolean;
  article: Article
  topNews?: boolean,
  topWithImg?: boolean,
  spotlightMiniTile?: boolean;
  tileClassName?: string;
  spotlightArticle?: boolean;
  listView?: boolean;
  summaryPadding?: string;
  popoverCustomClass?: string;
  feedSalesTrigger?: boolean;
} & typeof defaultProps;

const defaultProps = {
  hideCompanyName: false,
  favoritePageFlag: false,
  heroArticle: false,
  socialActivity: false,
  activityTile: false,
  searchArticleTile: false,
  personPersona: '',
  personImage: '',
  articleHeight: '280',
  articleHeightSm: '280',
  articleWidth: '570',
  topNews: false,
  topWithImg: false,
  spotlightMiniTile: false,
  tileClassName: '',
  spotlightArticle: false,
  listView: false,
  summaryPadding: '145px',
  popoverCustomClass: '',
  feedSalesTrigger: false,
};

const ArticleTileGlobal = function ArticleTileGlobal(props: Props) {
  const dispatch = useDispatch();

  const [visible, setVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  const certificationData = useSelector(selectData);
  const completed = useSelector(selectIsCertificationCompleted);
  const host = window.location.href;

  const {
    hideCompanyName,
    favoritePageFlag,
    heroArticle,
    socialActivity,
    activityTile,
    personPersona, personImage,
    searchArticleTile,
    articleHeight, articleHeightSm,
    articleWidth,
    article, topNews, topWithImg, spotlightMiniTile,
    spotlightArticle,
    tileClassName, listView,
    summaryPadding, popoverCustomClass,
    feedSalesTrigger,
  } = props;
  const articleTag = (article?.alerts[0]?.alert !== '');
  const certificationDrawer = useSelector(selectOpenDrawer);

  let hasImage = false;
  if (article.image) {
    hasImage = true;
  }
  let isImg = false;
  if (article.image === '') {
    isImg = true;
  }

  const toggleVisible = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    if (visible && (spotlightArticle || !completed)) {
      dispatch(certificationActions.certificationAction({
        type: 'spotlight_article_select',
        source: 'spotlight',
        data: certificationData,
      }));
    }
    if (visible && (spotlightArticle || spotlightMiniTile || searchArticleTile)) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject(spotlightArticle || spotlightMiniTile ? 'feedpage_spotlight_article_clicked' : 'searchPage_article_clicked', 0, {
          article_id: article.articleId,
          ...article.alerts[0]?.alertId && { alert_id: article.alerts[0]?.alertId },
          host,

        }),
      ));
    }
    if (visible && feedSalesTrigger) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('salesTrigger_article_clicked', 0, {
          article_id: article.articleId,
          ...article.alerts[0]?.alertId && { alert_id: article.alerts[0]?.alertId },
          host,

        }),
      ));
    }
  }, [visible]);

  useEffect(() => {
    if (certificationDrawer && visible) {
      setVisible(false);
    }
  }, [certificationDrawer]);

  const content = (
    <ContentWrapper className={`${popoverCustomClass}`}>
      <h6 className="heading-popover">QuickShare to:</h6>
      <SocialShareIcons
        spotlight={spotlightArticle}
        articleid={article.articleId}
        title={article.title}
        img={article.image}
        domain={article.domain}
        entity="article"
        url={article.url}
        alertId={(article?.alerts && article?.alerts.length > 0
          && article.alerts[0].alertId) || 0}
      />
    </ContentWrapper>
  );

  const handleOpenVisible = () => {
    if (article.articleType.toLowerCase() === 'news') { toggleVisible(); }
  };

  const addToFavorite = (articleId: number) => {
    const data = {
      articleId,
      favoriteFlag: article.isFavorite ? 0 : 1,
    };
    dispatch(favouriteArticleActions.addToFavorite(data));
  };

  useEffect(() => {
    if (visible && favoritePageFlag) {
      setVisible(false);
    }
  }, [article]);

  const handleOpenChange = (open: boolean) => {
    if (open) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('article_share_intent', 0, {
          host,
        }),
      ));
    }
  };

  const handleWebsiteClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation();
    window.open(article.url);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('article_weblink_clicked', 0, {
        host,
      }),
    ));
  };

  return (
    <>
      {listView ? (
        <ArticleListWrapper
          className={classNames(`${tileClassName}`, {
            notImage: isImg && activityTile,
          })}
          triggerColor={article?.alerts[0]?.color}
          summaryPadding={summaryPadding}
        >
          {
            article.image
            && (
              <div
                className="profile-area"
                onClick={handleOpenVisible}
                onKeyPress={handleOpenVisible}
                role="button"
                aria-label="Open or close"
                tabIndex={0}
              >
                <LazyLoadImage
                  src={setImageSize(
                    article.image,
                    85,
                    85,
                    article.articleId,
                  )}
                  className="img-fluid"
                  alt="" // its empty because of some reason
                  effect="blur"
                />
                {socialActivity && (
                  article.articleType.toLowerCase() === 'tweet' ? <TwitterIcon /> : <LinkedInIcon />
                )}

              </div>
            )
          }
          <div className="text-area">
            {heroArticle && article?.alerts.length > 0 && (
              <ArticleTag tagColor={article?.alerts[0]?.color} className="tagArticle c-auto">
                {article?.alerts[0]?.alert}
              </ArticleTag>
            )}
            <div className={classNames('title-summary-div', { tagArticleSummary: articleTag })}>
              <span
                className="heading text-truncate-one-line"
                onClick={handleOpenVisible}
                onKeyPress={handleOpenVisible}
                role="button"
                aria-label="open or close"
                tabIndex={0}
              >
                {HTMLReactParser(article.title)}
              </span>
              {article.articleType.toLowerCase() === 'news' ? (
                <span
                  className="article_summary text-truncate-one-line"
                  onClick={handleOpenVisible}
                  onKeyPress={handleOpenVisible}
                  role="button"
                  tabIndex={0}
                >
                  {article.summary.replace(/<[^>]+>/g, '')}
                </span>
              ) : null}
            </div>
            <div className="footer-data-article">
              <div
                className="bottom-tips"
                onClick={handleOpenVisible}
                onKeyPress={handleOpenVisible}
                role="button"
                aria-label="Close"
                tabIndex={0}
              >
                <div
                  className="tips domain text-truncate"
                  onClick={handleWebsiteClick}
                  onKeyPress={handleWebsiteClick}
                  role="button"
                  aria-label={`view ${article.domain}`}
                  tabIndex={0}
                >
                  {article.domain}

                </div>
                <div className="tips date text-truncate">{article.dateTimeStamp}</div>
                {article.companyName ? (
                  <div className="tips industry text-truncate">
                    {article.companyName}
                  </div>
                ) : null}
              </div>
              {!isGuest() && (
                <div className="share-actions-with-fav">
                  <span
                    className="favorite-icon-custom"
                    onClick={(e) => {
                      e.stopPropagation();
                      addToFavorite(article.articleId);
                    }}
                    onKeyPress={(e) => {
                      e.stopPropagation();
                      addToFavorite(article.articleId);
                    }}
                    tabIndex={0}
                    role="button"
                    aria-label="Faviourite"
                  >
                    <FavoriteIcon color={`${article.isFavorite ? favouriteArticleColor : whiteColor}`} />
                  </span>
                  <Popover
                    placement="left"
                    content={content}
                    trigger="click"
                    onOpenChange={handleOpenChange}
                    getPopupContainer={(e: HTMLElement) => e}
                    className="popover-sharing-custom line-block"
                  >
                    <div
                      className={classNames('article-share-icon', { listviewShareIcon: listView })}
                      aria-hidden="true"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <ShareArticleIcon />
                    </div>
                  </Popover>
                </div>
              )}
            </div>
          </div>
        </ArticleListWrapper>
      ) : (
        <ArticleWrapper
          articleHeight={articleHeight}
          articleHeightSm={articleHeightSm}
          triggerColor={article?.alerts[0]?.color}
          className={classNames(`article-item article-tile-global ${tileClassName}`, {
            heroView: heroArticle,
            socialActive: socialActivity,
            activityActive: activityTile,
            notImage: isImg && activityTile,
            topNewsStyle: isImg && topNews,
            searchTileWithOutTag: isImg && searchArticleTile,
            searchTile: searchArticleTile,
            notHeroView: !heroArticle,
            topWithImgTile: topWithImg,
            spotlightMiniTileView: spotlightMiniTile,
          })}
        >
          {
            article.image
            && (
              <div
                ref={elementRef}
                className={classNames('profile-area', { videoPlayIframe: article.videoUrl.length })}
                onClick={handleOpenVisible}
                onKeyPress={handleOpenVisible}
                role="button"
                aria-label="Open or close"
                tabIndex={0}
              >
                {heroArticle && article?.alerts.length > 0 && (
                  <ArticleTag tagColor={article?.alerts[0]?.color} className="tagArticle c-auto">
                    {article?.alerts[0]?.alert}
                  </ArticleTag>
                )}
                {article.videoUrl.length
                  ? (
                    <div
                      className="newsVideoFrame"
                    >
                      <Iframe
                        url={article.videoUrl}
                        width="100%"
                        height="280px"
                        id="videoFrameId"
                        className="videoFrame"
                        display="block"
                        position="relative"
                        scrolling="no"
                        frameBorder={0}
                      />
                    </div>
                  )
                  : (
                    <LazyLoadImage
                      src={setImageSize(
                        article.image,
                        elementRef.current?.clientWidth || articleWidth,
                        elementRef.current?.clientHeight || articleHeight,
                        article.articleId,
                      )}
                      className="img-fluid"
                      alt="article-image"
                      effect="blur"
                    />
                  )}

                {socialActivity && (
                  article.articleType.toLowerCase() === 'tweet' ? <TwitterIcon /> : <LinkedInIcon />
                )}

              </div>
            )
          }
          <div className="text-area">
            {(!hasImage || !heroArticle) && article?.alerts.length > 0 && (
              <ArticleTag tagColor={article?.alerts[0]?.color} className="tagArticle c-auto">
                {article?.alerts[0]?.alert}
              </ArticleTag>
            )}
            <div>
              {personImage
                && (
                  <div
                    className="person-area-activity"
                    onClick={handleOpenVisible}
                    onKeyPress={handleOpenVisible}
                    role="button"
                    tabIndex={0}
                    aria-label="View person information"
                  >
                    <PeopleWidget
                      diameter="92px"
                      persona={personPersona}
                      logo={personImage}
                    />
                    <span className="social-platform-placeholder">
                      <LinkedInIcon />
                    </span>
                  </div>
                )}
              <div className="person-activity-text-detail">
                <span
                  className="heading text-truncate-three-line"
                  onClick={handleOpenVisible}
                  onKeyPress={handleOpenVisible}
                  role="button"
                  aria-label="open or close"
                  tabIndex={0}
                >
                  {HTMLReactParser(article.title)}
                </span>
                {article.articleType.toLowerCase() === 'news' ? (
                  <span
                    className="article_summary text-truncate-two-line"
                    onClick={handleOpenVisible}
                    onKeyPress={handleOpenVisible}
                    role="button"
                    tabIndex={0}
                  >
                    {article.summary.replace(/<[^>]+>/g, '')}
                  </span>
                ) : null}
                <div className="footer-data-article">
                  <div
                    className="bottom-tips"
                    onClick={handleOpenVisible}
                    onKeyPress={handleOpenVisible}
                    role="button"
                    aria-label="Close"
                    tabIndex={0}
                  >
                    <div
                      className="tips domain"
                      onClick={handleWebsiteClick}
                      onKeyPress={handleWebsiteClick}
                      role="button"
                      aria-label={`view ${article.domain}`}
                      tabIndex={0}
                    >
                      {article.domain}

                    </div>
                    <div className={`tips ${article.companyName && !hideCompanyName ? 'separator' : 'separator-left'} date`}>{article.dateTimeStamp}</div>
                    {article.companyName && !hideCompanyName ? (
                      <div className="tips industry">
                        {article.companyName}
                      </div>
                    ) : null}
                  </div>
                  {!isGuest() && (
                    <div className="share-actions-with-fav">
                      <span
                        className="favorite-icon-custom"
                        onClick={(e) => {
                          e.stopPropagation();
                          addToFavorite(article.articleId);
                        }}
                        onKeyPress={(e) => {
                          e.stopPropagation();
                          addToFavorite(article.articleId);
                        }}
                        tabIndex={0}
                        role="button"
                        aria-label="Faviourite"
                      >
                        <FavoriteIcon color={`${article.isFavorite ? favouriteArticleColor : whiteColor}`} />
                      </span>
                      <Popover
                        placement="left"
                        content={content}
                        onOpenChange={handleOpenChange}
                        trigger="click"
                        getPopupContainer={(e: HTMLElement) => e}
                        className="popover-sharing-custom line-block"
                      >
                        <div
                          className={classNames('article-share-icon', { listviewShareIcon: listView })}
                          aria-hidden="true"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <ShareArticleIcon />
                        </div>
                      </Popover>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

        </ArticleWrapper>
      )}
      {
        article.articleType.toLowerCase() === 'news'
        && (
          <ArticleDrawer
            visible={visible}
            toggleVisible={toggleVisible}
            articleId={article.articleId}
            title={article.title}
            domain={article.domain}
            dateTimeStamp={article.dateTimeStamp}
            summary={article.summary}
            image={article.image}
            url={article.url}
            companyId={article.companyId}
            companyName={article.companyName}
            spotlight={spotlightArticle}
            articleAlert={article?.alerts}
          />
        )
      }
    </>
  );
};

ArticleTileGlobal.defaultProps = defaultProps;
export default ArticleTileGlobal;
